<ng-container *transloco="let t">
    @if (standingsMeta) {
    <ng-template [ngTemplateOutlet]="standingsTable"></ng-template>
    } @else {
    <app-empty-state [contentKeys]="['emptyState.list.results']"></app-empty-state>
    }
    <ng-template #standingsTable>
       <app-filter-panel [groups]="filterGroups"
                              (filterChange)="onFilterChange($event)"
                              [showFilterChips]="false"/>

        @if (results.length) {
        <div *ngIf="isMobile" class="mobile-table-top-header">
            <i class="bi bi-arrow-right"></i>
            <p>{{ t('app.common.swipe.to.explore') }}</p>
        </div>
        <div class="table-container" horizontalScrollableTable
             [class.public-table]="!isAdmin" [showScrollArrows]="!isMobile">
            <table class="table align-middle text-center no-vertical-border"
                   [class.table--hover]="isAdmin">
                <thead>
                <tr>
                    <th sticky [stickyWidth]="70" [stickyMobileWidth]="40">{{isMobile ? '#' : t('league.rank')}}</th>
                    <th sticky [stickyWidth]="250" [stickyMobileWidth]="200" scope="col" class="text-start">
                      @if( raceType === LeagueRaceType.INDIVIDUAL ) {
                        {{t('app.common.competitor')}}
                      } @else {
                        {{t('app.common.team')}}
                      }
                    </th>
                    <th sticky [stickyWidth]="80" [stickyMobileWidth]="60" [stickyDisabled]="isMobile">
                      {{isMobile ? t('league.points.alt') : t('league.points')}}
                    </th>
                    <th *ngIf="!isMobile" sticky [stickyWidth]="100">{{t('app.common.events')}}</th>
                    <th *ngIf="!isMobile" sticky [stickyWidth]="60">{{t('app.common.category.short')}}</th>
                    @for (col of roundColumns; track col.id) {
                    <th scope="col" class="round-col round-header col-width-170">
                         <div>
                            @if (!isAdmin) {
                                <div class="color-slate-800">{{col.round}} {{t('event.item.round') | uppercase}} </div>
                            }
                            <div class="text-truncate fw-400 text-truncate" [ngbTooltip]="col.name"
                                [class.fw-500]="isAdmin">
                                @if (isAdmin) {
                                    {{col.round}} {{t('event.item.round') | uppercase}} -
                                 }
                                {{col.name}}
                            </div>
                            @if (!isAdmin) {
                             <div class="fw-400">{{col.start | localizedDate:'dd.MM.yyyy' }}</div>
                            }
                        </div>
                    </th>
                    }
                    @if (isAdmin) {
                    <th scope="col" class="col-width-170">{{t('league.results.status')}}</th>
                    <th scope="col" class="col-width-170">{{t('league.results.warning')}}</th>
                    <th scope="col" class="col-width-170">{{t('league.results.actions')}}</th>
                    <th sticky [stickyWidth]="50" [stickyRight]="true"></th>
                    }
                </tr>
                </thead>
                <tbody #tbody infinite-scroll
                       [infiniteScrollDistance]="4"
                       (scrolled)="loadMore()">
                @for (result of results;track result) {
                    @let rankType = (filter?.categoryItemId != null ? 'category' : filter?.gender ? 'gender' : 'absolute');
                    @let rank = result.overallPoints | leagueRank:rankType;
                    <tr [class.firstRank]="!isAdmin && rank === 1" [class.secondRank]="!isAdmin && rank === 2" [class.thirdRank]="!isAdmin && rank === 3">
                      <td sticky [stickyWidth]="70" [stickyMobileWidth]="40" class="color-slate-800">
                        <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-md-1">
                          @if (!isAdmin) {
                            @if (rank === 1) {
                              <img src="assets/icons/cup_first_place.svg" alt="X" width="14" height="14">
                            }  @if (rank === 2) {
                              <img src="assets/icons/cup_second_place.svg" alt="X" width="14" height="14">
                            }  @if (rank === 3) {
                              <img src="assets/icons/cup_third_place.svg" alt="X" width="14" height="14">
                            }
                          }
                          <p>{{rank}}</p>
                        </div>

                      </td>
                <td sticky [stickyWidth]="250" [stickyMobileWidth]="200" class="text-start">
                  <div>
                    <div class="d-grid color-slate-800 fw-500" style="grid-template-columns: auto 1fr">
                      @if (result.leagueCompetitor?.country) {
                        <span [class]="'me-3 fi fi-'+ ((result.leagueCompetitor?.country | country:'isoCode') | lowercase)" style="border-radius: 4px;"></span>
                      }
                      @if (result.leagueCompetitor?.isTeam) {
                        <div>{{result.leagueCompetitor?.team ?? ''}}</div>
                      }
                      @else {
                        <div>{{result.leagueCompetitor?.firstName ?? ''}} {{result.leagueCompetitor?.lastName ?? ''}}</div>
                      }
                    </div>
                    <div *ngIf="isMobile" class="d-flex align-items-center fs-12">
                      <img src="assets/icons/icons-alt/orange-dot-sm.svg" alt="Dot" width="6" height="6" class="me-2">
                      <span>{{result.eventsCount ?? '-'}}/{{leagueEvents?.totalRounds}} {{t('app.common.races') | lowercase}}</span>
                      <i class="bi bi-dot"></i>
                      <span>
                        @if (result.leagueCompetitor?.categoryItemLabel) {
                          {{result.leagueCompetitor?.categoryItemLabel}}
                        }
                        @else {
                          {{((result.leagueCompetitor?.sex === 1 ||
                          result.leagueCompetitor?.sex === 2) ?
                          t('app.common.gender.short.' + result.leagueCompetitor?.sex) : "-") | uppercase}}
                        }
                      </span>
                    </div>
                  </div>
                </td>
                <td sticky [stickyWidth]="80" [stickyMobileWidth]="60" [stickyDisabled]="isMobile" class="color-slate-800">
                  {{result.overallPoints?.totalPoints ?? '-'}}
                </td>
                <td sticky *ngIf="!isMobile" [stickyWidth]="100">{{result.eventsCount ?? '-'}}/{{leagueEvents?.totalRounds}}</td>
                <td sticky *ngIf="!isMobile" [stickyWidth]="60" class="right-shadow">
                    @if (result.leagueCompetitor?.categoryItemLabel) {
                        {{result.leagueCompetitor?.categoryItemLabel}}
                    }
                    @else {
                    {{((result.leagueCompetitor?.sex === 1 ||
                        result.leagueCompetitor?.sex === 2) ?
                        t('app.common.gender.short.' + result.leagueCompetitor?.sex) : "-") | uppercase}}
                    }
                </td>
                @for (col of roundColumns; track col.id) {
                <td class="color-slate-800 col-width-170">
                    @if (result | resultByRound: col.id : col.raceIds; as rr) {
                      <div class="round-points">
                          <span class="round-points__final">{{ rr.basePoints ?? '-' }}</span>
                          @if (rr.bonus) {
                            <span class="round-points__bonus">+{{ rr.bonus }}</span>
                          }
                          @if (rr.penalty) {
                            <span class="round-points__penalty">-{{ rr.penalty }}</span>
                          }
                      </div>
                    } @else {
                      -
                    }
                </td>
                }
                @if (isAdmin) {
                <td></td>
                <td></td>
                <td>
                    <span>
<!--                        DETAILS-->
                    </span>
                </td>
                <td sticky [stickyWidth]="50" [stickyRight]="true">
                        <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                        <span class="menu-icon" ngbDropdownToggle>
                            <i class="fas fa-ellipsis-v"></i>
                             </span>
<!--                            <ul ngbDropdownMenu>-->
<!--                                <li ngbDropdownItem>-->
<!--                                    ACTION 1-->
<!--                                </li>-->
<!--                            </ul>-->
                        </div>
                </td>
                }
                }
                </tbody>
            </table>
        </div>
        }
        @else if(!isLoading) {
            <app-empty-state [contentKeys]="['emptyState.not.able.to.find']"/>
        }

    </ng-template>
</ng-container>
